import { saveToStorage } from "utils/localStorage";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
interface Props {
  setBanner: React.Dispatch<React.SetStateAction<string>>;
}
export const AlertBanner = ({ setBanner }: Props) => {
  const navigate = useNavigate();
  return (
    <div className="bg-[#00101C] max-h-[200px] md:px-0 px-2 pt-6 pb-6 text-center md:text-start  space-y-2 md:space-y-0 md:space-x-4 flex md:flex-row flex-col md:items-center md:justify-center">
      <div
        className="md:hidden cursor-pointer flex  justify-end"
        onClick={() => {
          saveToStorage("set-banner", "no", true);
          setBanner("no");
        }}
      >
        <IoClose className="text-[#9CA6A2] text-2xl" />
      </div>
      <p className="text-white  text-lg md:text-[28px] font-onestRegular md:leading-[30px]">
        Deliver for ₦0 via Safe Lockers during LockerDash
      </p>
      <p
        onClick={() => {
          saveToStorage("set-banner", "no", true);
          setBanner("no");
          navigate(`/dashboard/ship-now`);
        }}
        className="font-onestBold cursor-pointer text-lg  md:text-[28px] text-[#93E596]"
      >
        {" "}
        Book Now!
      </p>
      {/* <div
        className="md:block hidden z-[100] cursor-pointer"
        onClick={() => {
          saveToStorage("set-banner", "no");
          setBanner("no");
        }}
      >
        <IoClose className="text-[#9CA6A2] text-2xl" />
      </div> */}
    </div>
  );
};
